const errors = {
    ACCESS_DENIED: {
        code: '85e7ddb3-577c-4e24-8267-295fd49c525e',
        message: 'Odmowa dostępu.'
    },
    ACCOUNT_NOT_CONFIRMED: {
        code: '1b6fc10a-78fa-4884-ad65-7c1106ab3684',
        message: 'Aby się zalogować, musisz potwierdzić konto.'
    },
    BAD_CREDENTIALS: {
        code: '9f91ce90-6b60-47bd-9d8a-e9d4500d8476',
        message: 'Błędny login lub hasło.'
    },
    BUY_PROPOSAL_ALREADY_EXISTS: {
        code: '08e52c87-f2e5-454f-8185-b9f840ed23e5',
        message: 'Taka oferta już istnieje.'
    },
    CURRENT_PASSWORD_WRONG: {
        code: '1f51678d-4f6d-4aa8-8c9f-bedec8007209',
        message: 'Podano nieprawidłowe stare hasło.'
    },
    EMAIL_FORMAT_INVALID: {
        code: 'bd79c0ab-ddba-46cc-a703-a7a4b08de310',
        message: 'Nieprawidłowy adres email.'
    },
    JWT_TOKEN_EXPIRED: {
        code: '56b0066f-3919-4071-b8c7-ad4918188ea9',
        message: 'Uprawnienia wygasły. Zaloguj się ponownie.'
    },
    JWT_TOKEN_INVALID: {
        code: 'a22844cc-2f4a-4a16-a587-8cbe7a658527',
        message: 'Użytkownik niezautoryzowany.'
    },
    JWT_TOKEN_NOT_FOUND: {
        code: '7ae9d027-a435-4499-8c30-43cdfeee96e1',
        message: 'Brak tokena autoryzującego.'
    },
    NO_MATCHING_USERS_FOUND: {
        code: '50ec08a5-4c4e-4c43-8f9d-1639661f43ba',
        message: 'Nie znaleziono użytkowników spełniających podane kryteria.'
    },
    /* PASSWORD_LENGTH_WRONG: {
      code: 'e2a8ffcc-1572-42ed-99ca-ead10ef06556',
      message: 'Hasło powinno mieć dokładnie {{ count }} znaków.'
    }, */
    PASSWORD_TOO_SHORT: {
        code: '4d0e492f-1ca5-44f3-a63f-b53c0615f72e',
        message: 'Hasło powinno mieć co najmniej {{ min }} znaków.'
    },
    PASSWORD_TOO_LONG: {
        code: '6e63bcac-21e1-433e-a20d-ba7f21335d8d',
        message: 'Hasło powinno mieć maksymalnie {{ max }} znaków.'
    },
    PASSWORD_RESET_TOKEN_INVALID: {
        code: '6b3befbc-2f01-4ddf-be21-b57898905284',
        message: 'Nieprawidłowy token.'
    },
    SALE_OFFER_NOT_FOUND: {
        code: '85d7b4fa-f89f-4554-984d-f7aa1fcbba00',
        message: 'Oferta nie istnieje.'
    },
    SALE_OFFER_NOT_ACTIVE: {
        code: '85d7b4fa-ddc6-4114-b276-596078839eff',
        message: 'Oferta jest nieaktywna.'
    },
    CANNOT_ADD_TO_OWN_SALE_OFFER: {
        code: '85d7b4fa-cce4-499c-9cdf-956ab102fb19',
        message: 'Nie można złożyć propozycji do własnej oferty.'
    },
    USERNAME_ALREADY_EXISTS: {
        code: 'fec1df22-61b8-4b55-ae62-32317142267f',
        message: 'Podany login jest już zarejestrowany.'
    },
    /* USERNAME_LENGTH_WRONG: {
      code: '83be1e01-7aa5-412d-bc6b-3af4828aaaaf',
      message: 'Login powinien mieć dokładnie {{ count }} znaków.'
    }, */
    USERNAME_TOO_SHORT: {
        code: '00419ebe-b655-4f41-b6e6-68bb172a3ec8',
        message: 'Login powinien mieć co najmniej {{ min }} znaki.'
    },
    USERNAME_TOO_LONG: {
        code: 'cf8e57ea-1f76-41f7-87a2-fb5795637f7d',
        message: 'Login powinien mieć maksymalnie {{ max }} znaków.'
    },
    USER_NOT_FOUND_OR_ALREADY_CONFIRMED: {
        code: '0f708a67-23af-456f-889a-da866f74155a',
        message: 'Nie ma takiego konta lub zostało już potwierdzone.'
    },
    WRONG_OLD_PASSWORD: {
        code: 'user_password',
        message: 'Podano nieprawidłowe aktualne hasło.'
    },

    // Internal errors.

    MISSING_ROLE: {
        code: 'missing_role',
        message: 'Odmowa dostępu (brak wymaganej roli).'
    },
}

const methods = {
    getGenericError() {
        return {
            message: 'Coś poszło nie tak. Spróbuj później.',
        };
    },
    resolveError(error) {
        if (!(error instanceof Object) || !error.code) {
            return null; // Error not recognized - display the generic one.
        }

        let knownError;

        for (const knownErrorName in errors) {
            knownError = errors[knownErrorName];

            if (error.code === knownError.code) {
                return knownError;
            }
        }

        return null;
    },
    resolveErrors(errors) {
        let knownError, knownErrors = [];

        for (const error of errors) {
            knownError = this.resolveError(error);

            if (knownError) {
                knownErrors.push(knownError);
            }
        }

        return knownErrors;
    },
    resolveErrorsFromResponse(response) {
        if (!response || !response.data || !response.data.errors) {
            return null; // Unable to resolve (not a response or empty error collection).
        }

        return this.resolveErrors(response.data.errors);
    },
    resolveException(e) {
        if (!e) {
            return null;
        }

        if (e.response) {
            return this.resolveErrorsFromResponse(e.response);
        }

        return [this.resolveError(e)];
    },
}

export default {
    errors,
    methods,
}